export const FilterOperatorEnum = {
  include_any_of: 'include_any_of',
  include_all_of: 'include_all_of',
  exclude_if_any_of: 'exclude_if_any_of',
  exclude_if_all_of: 'exclude_if_all_of',
} as const;
export type FilterOperatorEnum =
  (typeof FilterOperatorEnum)[keyof typeof FilterOperatorEnum];
